module.exports = __webpack_public_path__ + "img/icon_NCDs_A03_af.d3467de9.png";